import { render, staticRenderFns } from "./KubernetesPanel.vue?vue&type=template&id=36a07576&scoped=true&"
import script from "./KubernetesPanel.vue?vue&type=script&lang=js&"
export * from "./KubernetesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a07576",
  null
  
)

export default component.exports